import styled, { css } from 'styled-components';
import { withMargins } from '../../mixins/withMargins';
import { linkDefaultProps } from './props';
const withSizes = ({ size = linkDefaultProps.size }) => {
    const sizes = {
        caption: css `
      font-size: var(--font-size-xxxs);
      line-height: var(--font-lineheight-medium);
    `,
        small: css `
      font-size: var(--font-size-xxs);
      line-height: var(--font-lineheight-distant);
    `,
        medium: css `
      font-size: var(--font-size-xs);
      line-height: var(--font-lineheight-superdistant);
    `,
        large: css `
      font-size: var(--font-size-sm);
      line-height: var(--font-lineheight-superdistant);
    `,
    };
    return sizes[size];
};
const withVariant = ({ variant = linkDefaultProps.variant, }) => {
    const variants = {
        main: css `
      color: var(--link-color-main-base);
      :hover {
        color: var(--link-color-main-hover);
      }
      :active {
        color: var(--link-color-main-active);
      }
    `,
        grey: css `
      color: var(--link-color-grey-base);
      :hover {
        color: var(--link-color-grey-hover);
      }
      :active {
        color: var(--link-color-grey-active);
      }
    `,
        inverted: css `
      color: var(--link-color-inverted-base);
      :hover {
        color: var(--link-color-inverted-hover);
      }
      :focus {
        outline: var(--border-width-thin) solid var(--color-neutral-70);
      }
      :active {
        color: var(--link-color-inverted-active);
      }
    `,
    };
    return variants[variant];
};
export const IconWrapper = styled.span `
  width: ${({ size }) => (size === 'caption' ? 16 : 24)}px;
  height: ${({ size }) => (size === 'caption' ? 16 : 24)}px;
  margin-left: ${({ position }) => (position === 'right' ? 'var(--spacing-0-5)' : 0)};
  margin-right: ${({ position }) => (position === 'left' ? 'var(--spacing-0-5)' : 0)};
  pointer-events: none;

  svg {
    fill: currentColor;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
`;
export const LinkContainer = styled.a `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 'fit-content';
  cursor: pointer;
  outline: none;
  font-family: var(--font-family);
  font-weight: var(--font-weight-semibold);

  ${({ underline }) => (underline ? `text-decoration: underline;` : 'text-decoration: none;')}

  :focus:not(:focus-visible) {
    outline: 0;
    box-shadow: none;
  }

  :focus {
    outline: var(--border-width-thin) solid var(--color-neutral-130);
    border-radius: var(--border-radius-xxs);
  }

  :hover {
    ${({ underline }) => (underline ? `text-decoration: none;` : 'text-decoration: underline;')}
  }

  ${withSizes}
  ${withVariant}
  ${withMargins}
`;
